import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import { Box, Grid, styled } from '@mui/material';
import { useState } from 'react';
import { Label, WsColors, EmbedVimeoVideo } from 'wisestep-base';

import { IFAQsProp } from '../../../../../helpAndKnowledgePage/components/browserExtension/BrowserExtension';
import FAQDetailsPage from '../../../../../helpAndKnowledgePage/components/FAQDetailsPage';
import HelpVideosLayoutPage from '../../HelpVideosLayoutPage';

const ImageStyle = styled(Box)(() => ({
  position: 'relative',
  display: 'inline-block',
  '.background-image': {
    height: '80%',
    width: '80%',
    position: 'relative',
  },
}));

const PlayIconStyle = styled(Box)(() => ({
  position: 'absolute',
  top: '63%',
  left: '40%',
  transform: 'translate(-50%, -50%)',
  cursor: 'pointer',
  color: 'GrayText',
}));

const HelpVideoChildComponent = ({ isFromSettings, topicArrayList }: IFAQsProp) => {
  return isFromSettings ? (
    <HelpVideosLayoutPage>
      <ChildComponent topicArrayList={topicArrayList} />
    </HelpVideosLayoutPage>
  ) : (
    <FAQDetailsPage>
      <ChildComponent topicArrayList={topicArrayList} />
    </FAQDetailsPage>
  );
};

const ChildComponent = ({ topicArrayList }: IFAQsProp) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState<string>('');
  const handleImageClick = (id: string) => {
    setDialogOpen(true);
    setSelectedVideoId(id);
  };
  const closeImageDialog = () => setDialogOpen(false);
  return (
    <Grid container item xs={12} alignContent="flex-start" bgcolor={WsColors.White} p={2}>
      {topicArrayList?.map((value, index) => (
        <Grid xs={4} key={index}>
          <Label>{value.label}</Label>
          <ImageStyle className="image-container" p={2}>
            <img
              src={`https://vumbnail.com/${value.id}.jpg`}
              alt="Thumbnail"
              className="background-image"
            />
            <PlayIconStyle className="icon-container">
              <PlayCircleFilledWhiteIcon onClick={() => handleImageClick(value.id)} />
            </PlayIconStyle>
          </ImageStyle>
        </Grid>
      ))}
      <EmbedVimeoVideo
        embedId={selectedVideoId}
        openDialog={dialogOpen}
        closeDialog={closeImageDialog}
      />
    </Grid>
  );
};

export default HelpVideoChildComponent;
